"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var contentBoxConfig = {
  hyperlink: 'WithExternalLinkIcon'
};
/* eslint-disable camelcase */

var ContentBox = function ContentBoxComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;

  if (sliceData[0].box_title.length === 0 && sliceData[0].box_content.length === 0) {
    return null;
  }

  return sliceData.map(function (_ref2) {
    var box_title = _ref2.box_title,
        box_content = _ref2.box_content;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-list__content-box-wrapper",
      key: box_title
    }, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "info-list__content-box-title"
    }, dataClient.textToMarkdown(box_title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-list__content-box-body"
    }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      content: box_content,
      baseClass: "info-list__content-box",
      options: contentBoxConfig
    })));
  });
};

ContentBox.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    box_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    box_content: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  })).isRequired
};
var _default = ContentBox;
exports["default"] = _default;